import { authenticationService } from '@/_services';

export const requestOptions = {
    get() {
        return {
            method: 'GET',
            ...headers()
        };
    },
    post(body) {
        return {
            method: 'POST',
            ...headers(),
            body: JSON.stringify(body)
        };
    },
    patch(body) {
        return {
            method: 'PATCH',
            ...headers(),
            body: JSON.stringify(body)
        };
    },
    put(body) {
        return {
            method: 'PUT',
            ...headers(),
            body: JSON.stringify(body)
        };
    },
    delete() {
        return {
            method: 'DELETE',
            ...headers()
        };
    }
}

function headers() {
    const currentUser = authenticationService.currentUserValue || {};
    const selectedTenant = localStorage.getItem('selectedTenantId');
    const selectedMp = localStorage.getItem('selectedMpId');

    const authHeader = currentUser.token ? { 'Authorization': 'Bearer ' + currentUser.token } : {};
    const tenantHeader = selectedTenant ? { 'TenantId': selectedTenant } : (currentUser.tenantId ? { 'TenantId': currentUser.tenantId.toString() } : {});
    const mpHeader = selectedMp ? { 'MpId': selectedMp } : (currentUser.mpId ? { 'MpId': currentUser.mpId.toString() } : {});

    return {
        headers: {
            ...authHeader,
            ...tenantHeader,
            ...mpHeader,
            'Content-Type': 'application/json'
        }
    }
}